import React from "react";
import Types from "prop-types";
import LanguageSelector from "../LanguageSelector";
import { ReCaptcha, fetchReCaptchaToken } from "../Guard";
import { withTranslation } from "react-i18next";
import axios from "axios";
import { Redirect } from "react-router-dom";
import eventAnalytics from "../../analytikaV2";
import { ANALYTIKA_EVENTS } from "../../utils/constants";
import { loadSheild } from "../../sheild";
import PasswordField from "../common/PasswordField";

class NewPassword extends React.Component {
  constructor(props) {
    super(props);

    loadSheild();
    eventAnalytics.setPageName(ANALYTIKA_EVENTS.PAGE.NEW_PASSWORD);
    eventAnalytics.publishV2(
      ANALYTIKA_EVENTS.IDNW_VIEW_PAGE,
      {
        page_name: ANALYTIKA_EVENTS.PAGE.NEW_PASSWORD,
      }
    );
    this.state = {
      password: "",
      error: null,
      isPasswordChanged: false,
      isInvalidPassword: false,
    };
  }

  onSubmit(event) {
    event.preventDefault();
    const token = this.props.match.params.token;

    const { password } = this.state;
    const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/recovery/password`;

    const queryParams = new URLSearchParams(this.props.location.search);
    const isMerchant = queryParams.get("merchant") === "true";

    this.setState({ submitting: true, error: null });

    let recaptchaPromise = fetchReCaptchaToken("forgot_password_email");

    recaptchaPromise
      .then((recaptchaToken) =>
        axios.put(endpoint, { token, password, recaptchaToken, ...(isMerchant && { kind: "merchant" }) })
      )
      .then((res) => {
        eventAnalytics.publishV2(
          ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE,
          {
            request_type: "password_reset",
            request_status: "success",
          }
        );
        return res.data;
      })
      .then((res) => this.setState({ isPasswordChanged: true }))
      .catch((err) => {
        eventAnalytics.publishV2(
          ANALYTIKA_EVENTS.IDNW_SEND_WEBRESPOSE,
          {
            request_type: "password_reset",
            request_status: "failed",
            error_code_string: err.response?.status?.toString(),
            error_description: err,
          }
        );
        this.setState({ submitting: false, error: err.response?.data?.description || err.response?.data?.message || err.response?.data });
      });
  }

  onChange(event) {
    const value = event.target.value;
    if (value.length <= 1) {
      eventAnalytics.publishV2(
        ANALYTIKA_EVENTS.IDNW_ENTER_PASSWORD,
        {
          dummy: "identity",
        }
      );
    }
    this.setState({ password: event.target.value });
  }

  onValidityChange(isInvalid) {
    this.setState({ isInvalidPassword: isInvalid });
  }

  componentDidMount() {
    document.title = "Reset password | Careem";
  }

  render() {
    const { t } = this.props;
    const { error, submitting, isPasswordChanged } = this.state;

    if (isPasswordChanged) {
      return <Redirect to="/password_success" />;
    }

    return (
      <form id="formNewPassword" onSubmit={this.onSubmit.bind(this)}>
        <LanguageSelector />
        <h1>{t("reset_password:enter_new_password")}</h1>
        {error && <div className="invalid show">{error}</div>}

        <PasswordField
          id="newPassword"
          name="newPassword"
          label={t("reset_password:new_password")}
          onChange={this.onChange.bind(this)}
          onValidityChange={this.onValidityChange.bind(this)}
          validateWeakPassword
          variant="classic"
        />

        <div className="material-form-field password-hint">
          {t("reset_password:strong_password_info")}
        </div>

        <input
          className="btn-careem"
          type="submit"
          value={submitting ? t("common:please_wait") : t("common:continue")}
          name="reset-pass-submit"
          disabled={submitting || this.state.isInvalidPassword}
          onClick={() =>
            eventAnalytics.publishV2(
              ANALYTIKA_EVENTS.IDNW_TAP_BUTTON,
              {
                button_name: "continue",
              }
            )
          }
        />

        <ReCaptcha />
      </form>
    );
  }
}

NewPassword.propTypes = {
  t: Types.func.isRequired,
};

export default withTranslation()(NewPassword);
